import { render, staticRenderFns } from "./CBProposalMaterialFacts.vue?vue&type=template&id=791e3e6e"
import script from "./CBProposalMaterialFacts.vue?vue&type=script&lang=js"
export * from "./CBProposalMaterialFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports